module.exports = __webpack_public_path__ + "static/media/discoverImg1.debc63b1.jpg";